import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { CONSTANTS } from 'src/Core/Constant';

@Component({
  selector: 'app-preview-pth',
  templateUrl: './preview-pth.component.html',
  styleUrls: ['./preview-pth.component.scss']
})
export class PreviewPthComponent implements OnInit {

  constructor(private toastr: ToastrService, private api: SevaProfileService) { }

  applicantData: any;
  sevaPrn: any = {};
  ApplicationTypeId = CONSTANTS.ApplicationTypeId.PTH;

  ngOnInit(): void {
    this.sevaPrn = history?.state?.rowData?.ApplicationGuid;
    this.getApplicantData();
  }

  getApplicantData() {
    this.api.apiCall(`Applicant/application/previewpth?ApplicationGuid=${this.sevaPrn}`, 'GET').subscribe((response: any) => {
      if (response.Data && Object.keys(response.Data).length > 0) {
        this.applicantData = response.Data;
      }
    }, (error) => {
      this.toastr.error('Failed to load PTH data');
    });
  }
}
